export default {"src":"/_next/static/media/grapefruit.d68997f2.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};